import { SELECT_SIZE } from '../_consts';
import Selections from '../_steps/enums/SizeStep';
import WizStepId from '../_steps/enums/WizStepId';
import type { UseButtonDisabledProps } from './useButtonDisabled';

export const useChargerButtonDisabled = ({
  currentStep,
  sizingSelector,
  size,
  isAccessory,
  gen4Enabled,
}: Partial<UseButtonDisabledProps>) => {
  return (
    (currentStep === WizStepId.Size &&
      sizingSelector === Selections.ChooseSize &&
      size?.value === SELECT_SIZE) ||
    (!size?.value && !gen4Enabled && isAccessory)
  );
};
